import { convertToPrice } from "../../utils/functions/currencies";

export const DebtBodyTemplate = (rowData: any) => {
  const hasDebt = rowData.debt > 0;

  return (
    <div className={`font-bold ${hasDebt ? "text-red-500" : "text-green-500"}`}>
      {hasDebt ? convertToPrice(rowData.debt) : "Sin deuda"}
    </div>
  );
};
